import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

tippy('[data-tippy-content]',{
  allowHTML: true,
  arrow: true,
  placement: 'bottom',
  trigger: 'mouseover click',
  interactive: true,
  interactiveBorder: 15,
  theme: 'light'
});

document.addEventListener('DOMContentLoaded', () => {
  initializeTooltips();
});

document.addEventListener('turbo:load', () => {
  initializeTooltips();
});

function initializeTooltips() {
  const tooltipElements = document.querySelectorAll('[data-toggle="tooltip"]');
  
  tooltipElements.forEach(element => {
    const content = element.getAttribute('data-title');
    const placement = element.getAttribute('data-placement') || 'top';
    
    tippy(element, {
      content: content,
      placement: placement,
      arrow: true,
      theme: 'light',
      allowHTML: true
    });
  });
}
